const routes = {
  home: "/",
  overview: "/facility/:facilityId/overview",
  openCases: "/facility/:facilityId/open-cases",
  archivedCases: "/facility/:facilityId/archived-cases",
  caseDetail: "/facility/:facilityId/case/:caseId",
}

export default routes
